import { c as _c } from "react/compiler-runtime";
import React, { FC, useContext } from 'react';
import { RootStoreContext } from '@stores/rootStore';
import Script from 'next/script';
export interface GoogleAnalyticsProps {
  measurementId: string;
}
export const GoogleAnalytics: FC<GoogleAnalyticsProps> = t0 => {
  const $ = _c(4);
  const {
    measurementId
  } = t0;
  const {
    userStore,
    uiStore
  } = useContext(RootStoreContext);
  let t1;
  if ($[0] !== measurementId || $[1] !== uiStore?.currentOrganization?.name || $[2] !== userStore) {
    t1 = uiStore?.currentOrganization?.name && measurementId && !userStore.isLF ? <><Script src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GA_ID}`} strategy="afterInteractive" /><Script id="ga" strategy="afterInteractive">{`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());    
              gtag('config', '${measurementId}', 
              { 
                'user_id': '${userStore?.user?.id}',
                'user_properties': { 
                  'organization': '${uiStore?.currentOrganization?.name || "N/A"}',
                  'lang': '${userStore?.user?.settings?.lang}'
                }
              });
          `}</Script></> : <></>;
    $[0] = measurementId;
    $[1] = uiStore?.currentOrganization?.name;
    $[2] = userStore;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};